const toNonEmptyString = (value) => {
  if (value == null) return null;
  const normalized = String(value).trim();
  return normalized.length > 0 ? normalized : null;
};

export const resolveOrderSerialBase = (...candidates) => {
  for (const candidate of candidates) {
    const normalized = toNonEmptyString(candidate);
    if (normalized) return normalized;
  }
  return null;
};

export const buildOrderCardSerialNumber = (orderNo, index = 0) => {
  const normalizedOrderNo = resolveOrderSerialBase(orderNo);
  const normalizedIndex = Number.isFinite(Number(index)) && Number(index) >= 0
    ? Math.floor(Number(index))
    : 0;
  const sequence = normalizedIndex + 1;

  return normalizedOrderNo
    ? `${normalizedOrderNo}-${sequence}`
    : `card-${sequence}`;
};

export const getPrimaryOrderSerialNumber = (orderNo) =>
  buildOrderCardSerialNumber(orderNo, 0);
